import { call, put, takeEvery } from "redux-saga/effects"

import { GET_ACTIONS, ADD_NEW_ACTION, UPDATE_ACTION, DELETE_ACTION } from "./actionTypes";
import {
    getActionsSuccess,
    getActionsFail,
    addActionSuccess,
    addActionFail,
    updateActionSuccess,
    updateActionFail,
    deleteActionSuccess,
    deleteActionFail,
   
} from "./actions"

import {
    getActions,
    addNewAction,
    updateAction,
    deleteAction,
   
} from "helpers/actions/actions_backend_helper";
import { toast } from "react-toastify";

function* fetchActions() {
    try {
        const response = yield call(getActions)
        yield put(getActionsSuccess(response))
    } catch (error) {
        yield put(getActionsFail(error))
    }
}

function* onAddNewAction({ payload: data }) {
    try {
        const response = yield call(addNewAction, data)
        yield put(addActionSuccess(response))
        toast.success("Feature  Added Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(addActionFail(error))
        toast.error("Feature  Added Failed", { autoClose: 2000 });
    }
}

function* onUpdateAction({ payload: data }) {
    try {
        const response = yield call(updateAction, data)
        yield put(updateActionSuccess(response))
        toast.success("Feature  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateActionFail(error))
        toast.error("Feature  Updated Failed", { autoClose: 2000 });
    }
}

function* onDeleteAction({ payload: data }) {

    try {
        const response = yield call(deleteAction, data)
        yield put(deleteActionSuccess(response))
        toast.success("Feature  Deleted Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(deleteActionFail(error))
        toast.error("Feature  Deleted Failed", { autoClose: 2000 });
    }
}


function* actionSaga() {
    yield takeEvery(GET_ACTIONS, fetchActions)
    yield takeEvery(ADD_NEW_ACTION, onAddNewAction)
    yield takeEvery(UPDATE_ACTION, onUpdateAction)
    yield takeEvery(DELETE_ACTION, onDeleteAction)
}

export default actionSaga;